import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ReactionDislikeIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps({ ...props, viewBox: "0 0 28 28" })}>
    <rect fill="#F0B91E" height="28" rx="14" width="28" />
    <path
      clipRule="evenodd"
      d="M14 3.5C8.201 3.5 3.5 8.201 3.5 14C3.5 19.799 8.201 24.5 14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.201 19.799 3.5 14 3.5Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.6887 10C11.7237 10 12.5637 10.8392 12.5637 11.875C12.5637 12.9107 11.7237 13.75 10.6887 13.75C9.65297 13.75 8.81372 12.9107 8.81372 11.875C8.81372 10.8392 9.65297 10 10.6887 10Z"
      fill="#C09418"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M17.4392 10C18.4742 10 19.3142 10.8392 19.3142 11.875C19.3142 12.9107 18.4742 13.75 17.4392 13.75C16.4035 13.75 15.5642 12.9107 15.5642 11.875C15.5642 10.8392 16.4035 10 17.4392 10Z"
      fill="#C09418"
      fillRule="evenodd"
    />
    <path
      d="M13.9921 16.1103C15.9291 16.0953 17.9392 16.668 19.4042 17.9042L19.6903 18.1611L19.7606 18.2353C20.0899 18.6203 20.0806 19.1995 19.7235 19.5741C19.3662 19.9488 18.7878 19.9856 18.3876 19.6747L18.3095 19.6083L18.1122 19.4316C17.0916 18.5724 15.5863 18.0981 14.0077 18.1103C12.3254 18.1232 10.7271 18.6868 9.70693 19.7069C9.31641 20.0975 8.68339 20.0975 8.29287 19.7069C7.90239 19.3164 7.90236 18.6834 8.29287 18.2929C9.77265 16.8131 11.9245 16.1262 13.9921 16.1103Z"
      fill="#C09418"
    />
  </svg>
);
